import request from '@/utils/request';

// 获取产品手册项目列表
export function getProductmanualarticleList(options) {
  return request({
    url: '/op/circle/',
    method: 'get',
    params: options
  });
}
// 添加
export function addManual(data) {
  return request({
    url: '/op/circle/',
    method: 'POST',
    data
  });
}
// 编辑
export function updateManual(id, data) {
  return request({
    url: '/op/circle/' + id,
    method: 'POST',
    data
  });
}
// 删除
export function deleteManual(id, data) {
  return request({
    url: '/op/circle/' + id,
    method: 'DELETE',
    data
  });
}
// 家校圈账号密码重置----------- 列表
export function pwdList(data) {
  return request({
    url: '/op/school-plate-repair/reset-password/',
    method: 'get',
    params: data
  });
}
// 家校圈账号密码重置----------- 列表
export function pwdReset(phone) {
  return request({
    url: `/op/school-plate-repair/reset-password/${phone}`,
    method: 'put'
  });
}

